import ExternalStorage from '@/services/ExternalStorage'

export default class Currencies {
  constructor ({ mainCurrencies, otherCurrencies, selectedOption, hotelCurrency }) {
    this.mainCurrencies = mainCurrencies || []
    this.otherCurrencies = otherCurrencies || []
    this.mainCurrenciesCodes = this.mainCurrencies.map(currency => currency.code)
    this.selectedOption = selectedOption || null
    this.hotelCurrency = hotelCurrency || null
  }

  static empty = () => new Currencies({})

  static savePreferredCurrencyCodeIntoCookie () {
    if (ExternalStorage.url.params.currencyCode) {
      ExternalStorage.cookies.savePreferredCurrency({ code: ExternalStorage.url.params.currencyCode })
    }
  }

  static deductSelectedCurrencyCode (hotelCurrencyCode) {
    if (ExternalStorage.url.params.currencyCode) return ExternalStorage.url.params.currencyCode
    if (ExternalStorage.url.params.displayInHotelCurrency !== null && ExternalStorage.url.params.displayInHotelCurrency !== undefined) return hotelCurrencyCode
    if (ExternalStorage.cookies.preferredCurrency()) return ExternalStorage.cookies.preferredCurrency()
    return hotelCurrencyCode
  }

  static computeCurrencies (currencies, selectedCurrencyCode, hotelCurrencyCode) {
    const mainCurrencyCodes = [hotelCurrencyCode, 'EUR', 'USD', 'GBP']
    const mainCurrencies = currencies
      .filter(currency => mainCurrencyCodes.includes(currency.code))
      .map(currency => {
        if (currency.code === hotelCurrencyCode) return { currency, order: 1 }
        switch (currency.code) {
          case 'USD': return { currency, order: 2 }
          case 'EUR': return { currency, order: 3 }
          case 'GBP': return { currency, order: 4 }
        }
      })
      .sort((a, b) => a.order - b.order)
      .map(obj => obj.currency)

    const otherCurrencies = currencies
      .filter(currency => !mainCurrencyCodes.includes(currency.code) && (currency.code !== 'LBP' && currency.code !== 'TRL'))
      .sort((a, b) => (a.code > b.code) ? 1 : ((b.code > a.code) ? -1 : 0))

    const hotelCurrency = currencies.find(currency => currency.code === hotelCurrencyCode)
    const selectedOption = currencies.find(currency => currency.code === selectedCurrencyCode) || hotelCurrency

    return new Currencies({ mainCurrencies, otherCurrencies, selectedOption, hotelCurrency })
  }

  filterByText (text) {
    const cleanText = text.trim().toLowerCase()
    const currencyMatchWithText = (currency) => (currency.code.toLowerCase().includes(cleanText) || currency.name.toLowerCase().includes(cleanText))
    const isMainCurrencyCode = (currencyCode) => this.mainCurrenciesCodes.includes(currencyCode)

    return {
      mainCurrencies: this.mainCurrencies.filter(currency => currencyMatchWithText(currency) && isMainCurrencyCode(currency.code)),
      otherCurrencies: this.otherCurrencies.filter(currency => currencyMatchWithText(currency) && !isMainCurrencyCode(currency.code))
    }
  }

  getCurrencyByCode = (currencyCode) => [...this.mainCurrencies, ...this.otherCurrencies].find(currency => currency.code === currencyCode)
  selectOption = (currency) => new Currencies({ ...this, selectedOption: currency })
  clone = () => new Currencies({ ...this })
}
